import { createApi } from '@reduxjs/toolkit/query/react';

import { CommonMin, UserMin } from '../common/dto/common.dto';
import { OrganisationViewDto } from '../common/dto/organisation.dto';
import { UserAccesByOrganisation } from '../common/types/user-store.types';
import customFetchBase from './base.service';

const API_URI = import.meta.env.VITE_UAA_SERVICE;
const TAG_TYPE = 'Admin';

interface ImpersonateUserAccess {
  organisations: CommonMin[];
  access: UserAccesByOrganisation;
  user: UserMin;
}

export const adminApi = createApi({
  reducerPath: 'adminApi',
  baseQuery: customFetchBase(`${API_URI}/admin`),
  tagTypes: [TAG_TYPE],
  endpoints: (builder) => ({
    getImpersonateUserAccess: builder.query<ImpersonateUserAccess, string>({
      query: (id: string) => {
        return `user-access/${id}`;
      },
      providesTags: [TAG_TYPE],
    }),
    getAdminOrganisation: builder.query<OrganisationViewDto, string>({
      query: (id: string) => {
        return `organisation/${id}`;
      },
      providesTags: [TAG_TYPE],
    }),
  }),
});

// auto-generated based on the defined endpoints
export const { useLazyGetImpersonateUserAccessQuery, useLazyGetAdminOrganisationQuery } = adminApi;
